import React from 'react';
import { Typography, Paper, Box, Grid, Divider } from '@mui/material';

const Profile = ({ data }) => {
 
  return (
    <Paper sx={{ p: 4, maxWidth: 500, mx: 'auto', boxShadow: 3, borderRadius: 2}}>
      <Typography variant="h5" gutterBottom align="center">
        Profile Information
      </Typography>
      <Divider sx={{ mb: 2 }} />

      <Grid container spacing={2}>
        <Grid item xs={6}>
          <Typography variant="subtitle1" color="textSecondary"><strong>Name:</strong></Typography>
        </Grid>
        <Grid item xs={6}>
          <Typography>{data.firstName} {data.lastName}</Typography>
        </Grid>

        <Grid item xs={6}>
          <Typography variant="subtitle1" color="textSecondary"><strong>Email:</strong></Typography>
        </Grid>
        <Grid item xs={6}>
          <Typography>{data.email}</Typography>
        </Grid>

        <Grid item xs={6}>
          <Typography variant="subtitle1" color="textSecondary"><strong>Gender:</strong></Typography>
        </Grid>
        <Grid item xs={6}>
          <Typography>{data.gender}</Typography>
        </Grid>

        <Grid item xs={6}>
          <Typography variant="subtitle1" color="textSecondary"><strong>Phone:</strong></Typography>
        </Grid>
        <Grid item xs={6}>
          <Typography>{data.phone}</Typography>
        </Grid>

        <Grid item xs={6}>
          <Typography variant="subtitle1" color="textSecondary"><strong> Fees:</strong></Typography>
        </Grid>
        <Grid item xs={6}>
          <Typography>{data.totalFees}/month</Typography>
        </Grid>

        <Grid item xs={6}>
          <Typography variant="subtitle1" color="textSecondary"><strong>Enrolled Course:</strong></Typography>
        </Grid>
        <Grid item xs={6}>
          <Typography>{data.courseName}</Typography>
        </Grid>
      </Grid>
    </Paper>
  );
};

export default Profile;
